import PropTypes from 'prop-types'
import { useRef, useEffect, useState, useContext } from 'react'
import { useTranslation } from 'next-i18next'

// Context
import { ModalContext } from '../../context/ModalContext'
import { UserContext } from '@/root/context/UserContext'
// Utils
import convertDataToTranslation from '../../utils/data/convertDataToTranslation'

// Internal components
import Svg from '../Svg/Svg'
import InfoBox from '../InfoBox/InfoBox'
import RichTextBlock from '../RichTextBlock/RichTextBlock'
import PlayerList from '../PlayerList/PlayerList'

const revealClass = ' is-revealed'
const activeClass = ' is-active'

const FormItemQuestion = (props) => {
  const { item, groupedState, revealState } = props

  const modalContext = useContext(ModalContext)
  const userContext = useContext(UserContext)
  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const createMarkup = (copy) => ({ __html: copy })

  const [isGrouped, setIsGrouped] = useState(false)
  const itemRef = useRef()

  useEffect(() => {
    if (item?.group && groupedState) {
      const itemLabel = item?.group?.label
      const groupedItem = groupedState.filter((str) => {
        return str.label.indexOf(itemLabel) >= 0
      })
      setIsGrouped(groupedItem[0].active)
    }
  }, [groupedState])

  // TO REFACTOR
  // Add a class to first Infobox element
  useEffect(() => {
    const element = document.querySelector('.InfoBox-wrapper')
    if (element) element.classList.add('InfoBox-first')
  }, [])

  const handleRedirectClick = (e) => {
    e.preventDefault()
    modalContext.setModalPromptRedirect(e.target.href)
    modalContext.setModalPromptTrigger(true)
  }

  useEffect(() => {
    const redirectEl = document.querySelector('.FormItem-questionRedirect')
    redirectEl?.addEventListener('click', handleRedirectClick)
    return () => redirectEl?.removeEventListener('click', handleRedirectClick)
  }, [modalContext.modalIsDirty])

  const getDynamicRichTextTranslation = () => {
    return item.richTextDynamic ? t(item.richText) : t(item.richText)
  }

  return (
    <div
      ref={itemRef}
      className={`FormItem ${item.infoBox ? 'FormItem--infoBox' : ''} FormItem--${item.type}${
        item.modifier ? ` FormItem--${item.modifier}` : ''
      }${revealState ? revealClass : ''}${!isGrouped ? '' : activeClass}`}
      data-reveal-target={item.revealed}
    >
      {item.heading && (
        <h3
          className="FormItem-questionHeading"
          dangerouslySetInnerHTML={createMarkup(!item.transl ? item.heading : t(item.heading))}
        ></h3>
      )}
      {item.subHeading && (
        <h4
          className="FormItem-questionSubHeading"
          dangerouslySetInnerHTML={createMarkup(!item.transl ? item.subHeading : t(item.subHeading))}
        ></h4>
      )}
      {item.label && (
        <p
          className="FormItem-questionCopy"
          dangerouslySetInnerHTML={createMarkup(!item.transl ? item.label : t(item.label))}
        ></p>
      )}
      {item.richText && (
        <RichTextBlock
          content={
            !item.richText.data && item.richText ? (!item.transl ? item.richText : getDynamicRichTextTranslation()) : ''
          }
          data={
            item.richText.data
              ? item.richText.data && item.richText.transl
                ? convertDataToTranslation(item.richText.data, t)
                : item.richText.data
              : []
          }
          modifiers={['RichTextBlock--modalContent']}
        />
      )}
      {item.note && (
        <p
          className="FormItem-questionNote"
          dangerouslySetInnerHTML={createMarkup(!item.transl ? item.note : t(item.note))}
        ></p>
      )}
      {item.alert && (
        <p className="FormItem-questionAlert">
          <span className="FormItem-questionAlertIndicator">!</span>
          <span className="FormItem-questionAlertCopy" dangerouslySetInnerHTML={createMarkup(item.alert)}></span>
        </p>
      )}
      {item.infoBox && (
        <InfoBox
          content={[item.infoBox]}
          modifiers={[`FormItem--infoBox ${item.infoBoxBottom ? 'FormItem--infoBoxBottom' : ''}`]}
        />
      )}
      {item.specialHeading && (
        <div className="FormItem-questionNotice">
          <hr className="FormItem-questionNoticeRuler" />
          <div className="FormItem-questionNoticeBlock">
            <Svg modifiers={['FormItem-questionNoticeIcon']} id={item.icon} />
            <div>
              <h3
                className="FormItem-questionNoticeTitle"
                dangerouslySetInnerHTML={createMarkup(t(item.specialHeading).toUpperCase())}
              ></h3>
              <p
                className="FormItem-questionNoticeDescription"
                dangerouslySetInnerHTML={createMarkup(t(item.specialSubheading))}
              ></p>
            </div>
          </div>
        </div>
      )}
      {item.playerlist && (
        <>
          {item.playerlist.title && (
            <h3
              className="FormItem-questionSubHeading"
              dangerouslySetInnerHTML={createMarkup(!item.transl ? item.playerlist.title : t(item.playerlist.title))}
            ></h3>
          )}
          {item.playerlist.description && (
            <p
              className="FormItem-questionNote"
              dangerouslySetInnerHTML={createMarkup(
                !item.transl ? item.playerlist.description : t(item.playerlist.description)
              )}
            ></p>
          )}
          {item.playerlist.list && <PlayerList playerList={[item.playerlist.list]} />}
        </>
      )}
    </div>
  )
}

FormItemQuestion.propTypes = {
  item: PropTypes.object,
  groupedState: PropTypes.any,
  revealState: PropTypes.any
}

export default FormItemQuestion
